const routes = [
  {
    path: '/workorder', // 工单模板列表
    name: 'workorder',
    component: () => import('@src/modules/workOrder/main'),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: 'index', // 工单管理
        name: 'workorderIndex',
        // component: () => import('@src/modules/workOrder/view/WorkOrderTemplate'),
        component: () => import('@src/modules/workOrder/view/home'),
        meta: {
          requireAuth: true,
          routerAlive: true,
          module: "workorder",
        },
      },
      {
        path: 'workArea', //工作区
        name: 'workorderArea',
        component: () => import('@src/modules/workOrder/view/WorkOrderTemplate'),
        meta: {
          requireAuth: false,
          module: "workorder",
        },
      },
      {
        path: 'list', // 工单列表
        name: 'workorderList',
        component: () => import('@src/modules/workOrder/view/WorkOrderList'),
        meta: {
          requireAuth: true,
          module: "workorder",
        },
      },
      {
        path: 'edit', // 工单字段编辑
        name: 'workorderEdit',
        component: () => import('@src/modules/workOrder/view/FieldEdit'),
        meta: {
          requireAuth: true,
          module: "workorder",
        },
      },
      {
        path: 'detail', // 工单详情
        name: 'workorderDetail',
        component: () => import('@src/modules/workOrder/view/WorkOrderDetail'),
        meta: {
          requireAuth: true,
          module: "workorder",
        },
      },
    ],
  },
]

export default routes
